import './ModalListCodeEvent.scss';

import { UnpyEvent } from 'domain/event/UnpyEvent';
import { UnpyEventView } from 'domain/event/UnpyEventView';
import { CodeEventList } from 'primary/codeEvent/list/CodeEventList';
import { useTranslate } from 'primary/hooks/useTranslate';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface ModalListCodeEventProps {
  handleClose: () => void;
  event: UnpyEvent | UnpyEventView;
}

export const ModalListCodeEvent = ({ event }: ModalListCodeEventProps) => {
  const t = useTranslate();
  const navigate = useNavigate();
  if (!event) return null;
  return (
    <div className={'modal-list-code-event'}>
      {event && <CodeEventList eventId={event.id} />}
    </div>
  );
};

export default ModalListCodeEvent;
